import { LCTOnlyDatasets } from "../../../../constants/enums"
import { DeviceFormDataWithAttachments } from "../../common/types/providerTypes"

export type EVACDeviceFormData = DeviceFormDataWithAttachments & {
    manufacturerId: string | null
    deviceMake: string
    deviceModel: string
    deviceModelRef: string
    barcodeNumber: string
    phases: number | "" | null
    voltage: number | "" | null
    maxCurrentAmpPerPhase: number | "" | null
    acOnlyOutput: boolean | null
    v2gCapability: boolean | null
    v2gExportCapacity: number | "" | null
    v2gCompletionDate: string // Date
    v2gG99gbG999niBoth: string | null
    v2gTtrStatus: string | ""
    comments: string
    systemReference: string | null
}

export type EVDCDeviceFormData = DeviceFormDataWithAttachments & {
    manufacturerId: string | null
    deviceMake: string
    deviceModel: string
    deviceModelRef: string
    deviceType: string | null
    deviceModule: string | null
    devicePhases: number | null
    deviceVoltage: number | null
    deviceTotInputRatedCurrent: number | null
    deviceTotInputRatedPower: number | null
    deviceMaxDemandCurrent: number | null
    deviceMaxDemandPower: number | null
    deviceModuleInputRatedCurrent: number | null
    deviceModuleInputRatedPower: number | null
    deviceHarmonicTestStandards: string | null
    deviceCommentsTestStandardsNotes: string
    systemReference: string | null
}

export type HpDeviceFormData = DeviceFormDataWithAttachments & {
    manufacturerId: string | null
    deviceMake: string
    deviceModel: string
    deviceModelRef: string
    heatPumpType: string | null
    function: string | null // Selects need to be nullable in form data
    devicePhases: number | null
    deviceVoltage: number | null
    deviceNomCurrentW35: number | null
    deviceNomCurrentW45: number | null
    deviceNomCurrentW55: number | null
    deviceNomCurrentW65: number | null
    deviceTotInputRatedCurrent: number | null
    deviceTotInputRatedPower: number | null
    deviceMaxDemandCurrent: number | null
    deviceMaxDemandPower: number | null
    deviceModule: string | null
    deviceModuleRef: string
    deviceProductCode: string
    deviceHarmonicStandards: string | null
    deviceFlickerStandards: string | null
    deviceIsBackUpHeaterPresent: string | null
    deviceBackUpHeaterPhases: number | null
    deviceBackUpHeaterModuleRef: string
    deviceBackUpHeaterModule: string | null
    deviceBackUpHeaterModuleInputRatedCurrent: number | null
    deviceBackUpHeaterModuleInputRatedPower: number | null
    deviceIsBoostHeaterPresent: string | null
    deviceBoostHeaterPhases: number | null
    deviceBoostHeaterModuleRef: string
    deviceBoostHeaterModule: string | null
    deviceBoostHeaterModuleInputRatedCurrent: number | null
    deviceBoostHeaterModuleInputRatedPower: number | null
    deviceIsWaterHeaterPresent: string | null
    deviceWaterHeaterPhases: number | null
    deviceWaterHeaterModuleRef: string
    deviceWaterHeaterModule: string | null
    deviceWaterHeaterModuleInputRatedCurrent: number | null
    deviceWaterHeaterModuleInputRatedPower: number | null
    deviceIsHeatPumpModulePresent: string | null
    deviceHeatPumpModulePhases: number | null
    deviceHeatPumpModuleRef: string
    deviceHeatPumpModule: string | null
    deviceHeatPumpModuleInputRatedCurrent: number | null
    deviceHeatPumpModuleInputRatedPower: number | null
    systemReference: string | null
}

export type DeviceFormData =
    | EVACDeviceFormData
    | EVDCDeviceFormData
    | HpDeviceFormData

/** Custom type guard to narrow form data */
export const isLctFormDataEvac = (
    formData: DeviceFormData,
    dataset: LCTOnlyDatasets
): formData is EVACDeviceFormData => dataset === LCTOnlyDatasets.EVAC

/** Custom type guard to narrow form data */
export const isLctFormDataEvdc = (
    formData: DeviceFormData,
    dataset: LCTOnlyDatasets
): formData is EVDCDeviceFormData => dataset === LCTOnlyDatasets.EVDC

/** Custom type guard to narrow form data */
export const isLctFormDataHp = (
    formData: DeviceFormData,
    dataset: LCTOnlyDatasets
): formData is HpDeviceFormData => dataset === LCTOnlyDatasets.HP

export type AssessEVACDeviceDetails = {
    ComplianceStatus: string
}

export type AssessEVDCDeviceDetails = {
    ComplianceStatus: string
    WorstCasePowerLevel: number
    ApplicableStandard: string
    SscMin3Phase: number
    ChargerSystemRatedLe75: number
    ChargerSystemRatedGe75: number
    InformationProvided: string
    InAccordanceWithEn61000311: number
    Zmax: number
}
